import { callApiWithAuthorization } from "../CallApi";

export async function createEntityConfigurations(projectId, entityProperties) {
    try {
        const request = await callApiWithAuthorization(`/api/v0/entity/${projectId}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(entityProperties),
        });
        const response = await request.json();
        return response;
    } catch (e) {
        return [null, e.message];
    }
}

export async function updateEntityAndConfiguration(id, properties) {
    try {
        const request = await callApiWithAuthorization(`/api/v0/updateEntityAndConfiguration/${id}`, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(properties)
        });
        const response = await request.json();
        return response;
    } catch (e) {
        console.error(e);
        throw e;
    }
}

export async function updateEntity(id, properties) {
    try {
        const request = await callApiWithAuthorization(`/api/v0/entity/${id}`, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(properties)
        });
        const response = await request.json();
        return response;
    } catch (e) {
        console.error(e);
        throw e;
    }
}

export async function getEntities(projectId) {
    let request = await callApiWithAuthorization("/api/v0/entities/" + projectId);
    let result = await request.json();
    return result;
}

export async function deleteEntity(projectId, entityId) {
    const request = await callApiWithAuthorization("/api/v0/project/" + projectId + "/entity/" + entityId, {
        method: "DELETE",
        headers: {
            "Content-Type": "application/json",
        }
    });
    const response = await request.json();
    return response;
}

export async function bulkDeleteEnities(projectId, entityIds) {
    const request = await callApiWithAuthorization("/api/v0/project/" + projectId + "/entities", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            entityIds: entityIds
        }),
    });
    const response = await request.json();
    return response;
}

export async function getPortalEntitiesAndPagesConfigurations(portalId, projectId) {
    const request = await callApiWithAuthorization(`/api/v0/project/${projectId}/portal/${portalId}/getPortalEntitiesAndPagesConfigurations`);
    const response = await request.json();
    return response;
}

export async function updateEntitiesConfigurations(data, portalId) {
    const request = await callApiWithAuthorization(`/api/v0/updateEntitiesConfigurations?portalId=` + portalId, {
        method: "PUT",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(data)
    });
    const response = await request.json();
    return response;
}

/**
 * Returns an array of entities that are the target of a mirror attribute on the entity with the given id.
 * @param {string} entityId id of the entity to get mirror attribute target entities for
 * @returns {Promise<Array<Entity>>} an array of entities that are the target of a mirror attribute on the entity with the given id
 */
export async function getMirrorAttributeTargetEntities(entityId) {
    try {
        const request = await callApiWithAuthorization(
            `/api/v0/entity/${entityId}/mirror-attribute-entity-targets`
        );
        const response = await request.json();
        return response;
    } catch (e) {
        return e.message;
    }
}

export async function getEntityById(entityId) {
    const request = await callApiWithAuthorization(
        `/api/v0/entity/${entityId}`
    );
    const response = await request.json();
    return response;
}